import { Rule } from "antd/es/form";

const validateMessages = {
  required: "${label} required",
  types: {
    email: "${label} not valid email",
    number: "${label} not valid number",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

export default validateMessages;
export const requiredRule: Rule = { required: true, message: "Required" };

export const maxNumberValidate = (input: number, maxValue: number) => {
  if (input > maxValue)
    return Promise.reject(new Error(`最大入力文字は${maxValue}です`));
  return Promise.resolve();
};

export const maxCharectersValidate = (input: string, maxValue: number) => {
  if (input.length > maxValue)
    return Promise.reject();
  return Promise.resolve();
};

export const noSpaceValidator = (value: string) => {
  if (value && value.includes(" ")) {
    return Promise.reject();
  }
  return Promise.resolve();
};

export const digitsValidator = (_: any, value: string) => {
  // Regex to match English (0-9) and Bangla (০-৯) and Arabic (٠-٩) digits
  const regex = /^[0-9০-৯٠-٩]*$/;
  if (!value || regex.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject();
};